import React from 'react';
import { useNotifications } from 'app/hooks/DynamoDBhooks/useNotifications';

type Props = {};

const useNotificationPanel = (props: Props) => {
  const [open, setOpen] = React.useState(false);
  
  // Use our custom hook for fetching notifications from DynamoDB
  const { data, unread, loading, error, markAllAsRead } = useNotifications();
  
  // Mark all notifications as read when the panel opens
  React.useEffect(() => {
    if (open) {
      markAllAsRead();
    }
  }, [open, markAllAsRead]);

  return {
    unread,
    data,
    open,
    setOpen,
    loading,
    error
  };
};

export default useNotificationPanel;
